import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import DynamicTable from './DynamicTable';
import DynamicTableStores from './DynamicTableStores';
import CustomDatePicker from './CustomDatePicker';
import Spinner from '../utils/Spinner';
import ValidView from "../../components/app/validView";
import dateToISOString from '../../components/app/dateToISOString';

const Reports = () => {

  const { allowWrite, allowView, userToken } = ValidView("Reports");
  const [ordersReport, setOrdersReport] = useState({});
  const [storesReport, setStoresReport] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedStore, setSelectedStore] = useState(null);
  const [timer, setTimer] = useState(null);
  const styles = { cardContainer: { maxHeight: '496px', overflowY: 'auto', marginBottom: '20px' } };
  const currentDate = new Date();
  const startDate = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);

  const [dates, setDates] = useState({
    startDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 0, 0, 0, 0),
    endDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 23, 59, 59, 999),
  });

  useEffect(() => {
    if (userToken) {
      fetchOrdersReport(dates.startDate, dates.endDate);
    }
  }, [userToken]);

  const fetchOrdersReport = async (startDate, endDate) => {
    try {

      const requestOptions = {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + userToken
        }
      };

      const startDateISOString = dateToISOString(startDate);
      const endDateISOString = dateToISOString(endDate, true);

      const response = await fetch(process.env.REACT_APP_NERTHUS_API_URL + '/reports/orders/' + `${startDateISOString}/${endDateISOString}` + '/100?timezone=-5', requestOptions);
      const data = await response.json();
      setStoresReport(data.data.topStoresReport);
      setOrdersReport(data.data.ordersReport);
      setIsLoading(false);

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handlerDates = () => {
    setIsLoading(true);
    setOrdersReport({});
    setStoresReport([]);
    setSelectedStore(null);

    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }

    setTimer(
      setTimeout(() => {
        setDates({ startDate: new Date(dates.startDate), endDate: new Date(dates.endDate) });
        fetchOrdersReport(dates.startDate, dates.endDate);
      }, 1500)
    );
  };

  return (
    <>
      {isLoading ? <Spinner /> : null}
      <Container fluid className='dashboard'>
        <CustomDatePicker dates={dates} setDates={setDates} handlerDates={handlerDates} />
        <Row>

          <Col md={4}>
            <Card className='card' border="primary" style={styles.cardContainer}>
              <Card.Header>Total Sales</Card.Header>
              <Card.Body>
                <div>
                  <DynamicTable data={ordersReport} />
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col md={4} className='sidebar'>
            <Card className='card' border="success" style={styles.cardContainer}>
              <Card.Header>Stores</Card.Header>
              <Card.Body>
                <div>
                  <DynamicTableStores topStoresReport={storesReport} setSelectedStore={setSelectedStore} />
                </div>
              </Card.Body>
            </Card>
          </Col>

          <Col md={4} className='sidebar'>
            <Card className='card' border="primary" style={styles.cardContainer}>
              <Card.Header>Store Detail</Card.Header>
              <Card.Body>
                {selectedStore ? (
                  <DynamicTable data={selectedStore} />
                ) : (
                  <p>Select a store to view detail</p>
                )}
              </Card.Body>
            </Card>
          </Col>

        </Row>
      </Container>
    </>
  );
};

export default Reports;